import React from "react";
import miscUtils from "utils/miscUtils";
import './EntryComponent.scss';
import ChannelHashTag from "components/sidebar/newIcons/ChannelHashTag";
import { Emoji } from "emoji-mart";

interface EntryComponentProps {
  mention: {
    name: string;
    id: string;
    avatar?: string;
    slug?: string;
  };
  theme: {
    mentionSuggestionsEntryContainer: string;
    mentionSuggestionsEntryContainerRight: string;
    mentionSuggestionsEntryText: string;
  };
  searchValue?: string;
  isFocused?: boolean;
}


const EntryComponent: React.FC<EntryComponentProps> = ({
  mention,
  theme,
  searchValue,
  isFocused,
  ...parentProps
}) => {

  const [isValidImage, setIsValidImage] = React.useState(true);
  const onImageError = (e: any) => {
    setIsValidImage(false)
  }

  return (
    <div {...parentProps}>
      <div className={`${theme.mentionSuggestionsEntryContainer} mention-entry-container`}>
        <div
          data-role-id={`${mention.id}`}
          className={`${theme.mentionSuggestionsEntryContainerRight} mention-entry-right`}
        >
          <div className={`${theme.mentionSuggestionsEntryText} mention-entry-text`}
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            {
              mention.slug
                ?
                <div className="mention-emoji-container">
                  {
                    mention.avatar ?
                      <span
                        dangerouslySetInnerHTML={{
                          //@ts-ignore
                          __html: Emoji({
                            html: true,
                            set: "apple",
                            emoji: mention.avatar,
                            size: 18
                          })
                        }}
                      />
                      :
                      <ChannelHashTag fill="#000" />
                  }
                </div>
                :
                <>
                  {(mention.avatar && isValidImage) ? (
                    <img src={mention.avatar} alt="av" className="avatar-image mention-entry-avatar-image"
                      onError={onImageError} />
                  ) : (
                    <div
                      className="mention-no-avatar mention-entry-no-avatar"
                      data-color={miscUtils.getColorInitial(`${mention.name}`)}
                    >
                      {miscUtils.getNameInitials(mention.name)}
                    </div>
                  )}

                </>
            }
            <span className="member-name mention-entry-name">{mention.name}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EntryComponent;
